import { render, staticRenderFns } from "./AppWebHookConfig.vue?vue&type=template&id=60bc48b3&scoped=true&"
import script from "./AppWebHookConfig.vue?vue&type=script&lang=js&"
export * from "./AppWebHookConfig.vue?vue&type=script&lang=js&"
import style0 from "./AppWebHookConfig.vue?vue&type=style&index=0&id=60bc48b3&scoped=true&lang=css&"
import style1 from "./AppWebHookConfig.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bc48b3",
  null
  
)

export default component.exports